module.exports = __webpack_public_path__ + "static/media/happy-april-fools-bts.2af49a38.png";